import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { getNrkIdFromNrkUrl, isNrkUrl } from '../../../utils/parsePastedVideoEmbedUrl';
import { zIndexes } from '../../../utils/zIndexes';
import NrkViewer from '../NrkViewer';
import { SlideWrapperContext } from '../SlideWrapper/SlideWrapper';

function VideoURLRenderer({
  videoId,
  altText,
  style,
}: {
  style?: React.CSSProperties;
  altText?: string | null;
  videoId: string;
}) {
  const { t } = useTranslation('Host');
  const { disabledMedia } = useContext(SlideWrapperContext);

  if (isNrkUrl(videoId)) {
    return (
      <NrkViewer disabledMedia={disabledMedia} nrkId={getNrkIdFromNrkUrl(videoId)} />
    );
  }

  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        height: '100%',
        zIndex: zIndexes('VIDEO_URL_RENDERER'),

        ...style,
      }}
    >
      <iframe
        src={videoId}
        data-src={videoId}
        id="videoIframe"
        style={{
          height: '100%',
          width: '100%',
          borderRadius: '10px',
          border: 'none',
          overflow: disabledMedia ? 'hidden' : 'visible',
          pointerEvents: disabledMedia ? 'none' : 'auto',
          zIndex: zIndexes('VIDEO_URL_RENDERER'),
          ...style,
        }}
        title={altText || t('video content')}
        allowFullScreen
      ></iframe>
      {disabledMedia && (
        <img
          src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs="
          alt={altText ? altText : ''}
          style={{
            position: 'absolute',
            width: '100%',
            height: '100%',
            zIndex: 1,
            top: 0,
            left: 0,
            ...style,
          }}
        ></img>
      )}
    </div>
  );
}

export default VideoURLRenderer;
